<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="290">
      <template v-slot:activator="{ on }">
        <v-btn color="secondary" v-on="on" dark style="border-radius: 12px;">Finalizar Campeonato</v-btn>
      </template>
      <v-card>
        <v-card-title>Colocação</v-card-title>
        <v-card-text v-if="allChampTeams">
          <v-layout mb-4 justify-space-between>
            <v-flex xs3 md3 sm3>
              <team-shield :avatarSize="35" :avatar="team_1? team_1.team_logo : null"></team-shield>
            </v-flex>
            <v-flex xs9 md9 sm9>
              <v-select
                return-object
                :items="allChampTeams"
                item-value="id"
                item-text="team_name"
                label="Primeiro Lugar"
                v-model="team_1"
                solo
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout mb-4 justify-space-between>
            <v-flex xs3 md3 sm3>
              <team-shield :avatarSize="35" :avatar="team_2? team_2.team_logo : null"></team-shield>
            </v-flex>
            <v-flex xs9 md9 sm9>
              <v-select
                return-object
                :items="allChampTeams"
                item-value="id"
                item-text="team_name"
                label="Segundo Lugar"
                v-model="team_2"
                solo
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout mb-4 justify-space-between>
            <v-flex xs3 md3 sm3>
              <team-shield :avatarSize="35" :avatar="team_3? team_3.team_logo : null"></team-shield>
            </v-flex>
            <v-flex xs9 md9 sm9>
              <v-select
                return-object
                :items="allChampTeams"
                item-value="id"
                item-text="team_name"
                label="Terceiro Lugar"
                solo
                clearable
                v-model="team_3"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-card-actions>
          <v-btn
            color="green darken-1"
            text
            @click="team_1=null, team_2 =null, team_3 =null ,dialog = false"
          >Cancelar</v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="confirm()"
            :disabled="team_1? false: true"
          >Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import api from "../../../api/index";

export default {
  components: {
    TeamShield: () => import("@/components/Teams/TeamShield.vue")
  },
  data() {
    return {
      dialog: false,
      loading: false,
      team_1: null,
      team_2: null,
      team_3: null
    };
  },
  methods: {
    confirm() {
      (async () => {
        const { value: confirmation } = await this.$swal({
          title: "Deseja finalizar o campeonato?",
          text: "Não é possível reverter essa ação",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#003a3e",
          cancelButtonText: "Não"
        });

        if (confirmation) {
          this.submitWinners();
        }
      })();
    },
    submitWinners() {
      this.loading = true;
      let fst = null;
      let snd = null;
      let trd = null;
      let winners = [];
      if (this.team_1) {
        fst = {
          champ_team_id: this.team_1.id,
          position: 1,
          edition_id: this.$route.params.id
        };
        winners.push(fst);
      }
      if (this.team_2) {
        snd = {
          champ_team_id: this.team_2.id,
          position: 2,
          edition_id: this.$route.params.id
        };
        winners.push(snd);
      }
      if (this.team_3) {
        trd = {
          champ_team_id: this.team_3.id,
          position: 3,
          edition_id: this.$route.params.id
        };
        winners.push(trd);
      }
      let winners_attributes = {};
      let edition = {
        id: this.$route.params.id,
        winners_attributes: {
          ...winners
        }
      };
      setTimeout(() => {
        api.Edition.updateEdition(edition)
          .then(r => r.data)
          .then(data => {
            console.log(data);
            this.loading = false;
            this.dialog = false;
            this.getOneChampionship({ id: this.$route.params.id });
          })
          .catch(error => {
            console.log({ error });
            this.loading = false;
          });
      }, 2000);
    },

    ...mapActions({
      getChampTeams: "ChampTeam/index",
      getOneChampionship: "Championship/show"
    })
  },
  computed: {
    ...mapState({
      allChampTeams: state => state.ChampTeam.allChampTeams
    })
  },
  mounted() {
    if (!this.allChampTeams) {
      this.getChampTeams(this.$route.params.id);
    }
  }
};
</script>

<style scoped>
</style>